(function () {
  if (window.__xmasQuickAdd) return;
  window.__xmasQuickAdd = true;

  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (err) {}
  }

  // Record each Christmas block once when it scrolls into view.
  function watchBlocks() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          track('christmas_block_view', { block: en.target.getAttribute('data-xmas-block') });
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-xmas-block]').forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchBlocks); else watchBlocks();

  // Show the matching variant photo when a pill is hovered, focused or tapped, or an option is chosen.
  function cardImg(el) {
    var box = el.closest('.xmas-card, .xmas-mini, .xmas-feature__main');
    return box ? box.querySelector('.xmas-card__img img, .xmas-mini__img img, .xmas-media img') : null;
  }
  function showImg(img, url) {
    if (!img || !url) return;
    if (!img.dataset.xmasOrig) { img.dataset.xmasOrig = img.currentSrc || img.src; img.dataset.xmasOrigSet = img.getAttribute('srcset') || ''; }
    img.removeAttribute('srcset');
    img.src = url;
  }
  function restoreImg(img) {
    if (!img || !img.dataset.xmasOrig) return;
    var keep = img.dataset.xmasPicked;
    if (keep) { img.src = keep; return; }
    img.src = img.dataset.xmasOrig;
    if (img.dataset.xmasOrigSet) img.setAttribute('srcset', img.dataset.xmasOrigSet);
  }
  function pick(el, url) {
    var img = cardImg(el);
    if (!img || !url) return;
    showImg(img, url);
    img.dataset.xmasPicked = url;
    var wrap = el.closest('.xmas-qa__pills');
    if (wrap) wrap.querySelectorAll('.xmas-pill').forEach(function (p) { p.classList.toggle('is-picked', p === el); });
  }
  document.addEventListener('mouseover', function (e) {
    var p = e.target.closest ? e.target.closest('.xmas-pill[data-img]') : null;
    if (p) showImg(cardImg(p), p.getAttribute('data-img'));
  });
  document.addEventListener('mouseout', function (e) {
    var p = e.target.closest ? e.target.closest('.xmas-pill[data-img]') : null;
    if (p && !p.contains(e.relatedTarget)) restoreImg(cardImg(p));
  });
  document.addEventListener('focusin', function (e) {
    var p = e.target.closest ? e.target.closest('.xmas-pill[data-img]') : null;
    if (p) pick(p, p.getAttribute('data-img'));
  });
  document.addEventListener('click', function (e) {
    var p = e.target.closest ? e.target.closest('.xmas-pill[data-img]') : null;
    if (p) pick(p, p.getAttribute('data-img'));
  }, true);
  document.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('.xmas-qa__select') : null;
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    if (opt) pick(sel, opt.getAttribute('data-img'));
  });

  function setStatus(form, text) {
    var s = form.querySelector('.xmas-qa__status');
    if (s) s.textContent = text;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[data-xmas-qa]') : null;
    if (!form || !window.fetch || !window.FormData) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return; // no drawer: let the normal form post go to the cart
    e.preventDefault();

    var btn = e.submitter || form.querySelector('[type="submit"]');
    var fd = new FormData(form);
    if (btn && btn.name === 'id') fd.set('id', btn.value);
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    setStatus(form, 'Adding…');

    fetch(form.getAttribute('action') + '.js', {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        if (!res.ok) {
          setStatus(form, (res.json && (res.json.description || res.json.message)) || 'Sorry, that could not be added.');
          return;
        }
        setStatus(form, 'Added to your basket');
        track('christmas_add_to_basket', { block: form.getAttribute('data-block'), variant_id: String(fd.get('id')) });
        if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); setStatus(form, ''); }, 2500); }
        var cartForm = drawer.querySelector('cart-form');
        if (cartForm && typeof cartForm.refresh === 'function') cartForm.refresh();
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: btn } }));
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        form.submit();
      });
  });
})();
